const initJobApplication = () => {
    const jobForm = document.getElementById('jobdetails-application-form');
    const button = jobForm?.querySelector('button');
    const fileInputFields = jobForm?.querySelectorAll('input[type="file"]');
    const fileInputWrapper = document.getElementById('jobdetails-application-file-upload');
    const maxFileSizeString = fileInputWrapper?.getAttribute('max-file-size');
    const maxTotalFilesSizeString = fileInputWrapper?.getAttribute('max-total-files-size');
    const maxFileSize = maxFileSizeString ? parseInt(maxFileSizeString.replace('MB', '')) * 1024 * 1024 : 10485760;
    const maxTotalFilesSize = maxTotalFilesSizeString ? parseInt(maxTotalFilesSizeString.replace('MB', '')) * 1024 * 1024 : 41943040;
    const errorMessage = document.querySelector('#jobdetails-application-error-message');
    const originalErrorText = errorMessage?.innerHTML;

    let currentFileSizeTotal = 0;
    let uploadId = null;

    const jobApplication = async () => {
        if (jobForm) {
            jobForm.addEventListener('submit', handleSubmit);
        }

        if (fileInputFields?.length) {
            fileInputFields.forEach((fileInputField) => {
                fileInputField.addEventListener('change', handleUpload);
            });
        }
    };

    const handleQuestionMapping = (payload, item) => {
        if (!!['question-answer', 'question-locale', 'question-order'].find((x) => x === item.name)) {
            if (!payload[item.name]) {
                payload[item.name] = [];
            }
            payload[item.name].push(item.value ?? '');
            return true;
        }
        return false;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const loadingElement = document.querySelector('#loadingElement');
        loadingElement.style.display = 'block';

        const formElements = [...jobForm.elements];
        let valid = true;
        const payload = {};

        formElements.forEach((item) => {
            if (!item.value && item) {
                if (item.required) {
                    item.classList.add('error');
                    valid = false;
                } else {
                    handleQuestionMapping(payload, item);
                }
            } else {
                if (!!item.name && item.name !== 'upload-file-title' && item.name !== 'upload-cv' && item.name !== 'upload-cover-letter' && item.name !== 'upload-other') {
                    if (!handleQuestionMapping(payload, item)) {
                        payload[item.name] = item.value;
                    }
                }
            }
        });

        if (valid) {
            payload['upload-id'] = uploadId;

            const urlPrefix =
                window.location.hostname === 'localhost' && (window.location.port === '8080' || window.location.port === '8081')
                    ? '/belimo-local-mysql'
                    : '';

            try {
                const request = await fetch(`${urlPrefix}/.rest/successfactors/v1/job-details/jobApplicationForm`, {
                    method: 'POST',
                    body: JSON.stringify(payload),
                    headers: {
                        'content-type': 'application/json'
                    }
                });

                const result = await request.json();

                if (!result.error) {
                    const successMessage = document.querySelector('#jobdetails-application-success-message');
                    const overlay = document.querySelector('#job-application-overlay');
                    overlay.close();
                    jobForm.style.display = 'none';
                    successMessage.style.display = 'block';
                    successMessage.scrollIntoView();
                } else {
                    const errorObject = JSON.parse(result.errorMessage);
                    let errorText = remoteErrors.get(errorObject.code);
                    if (errorText === undefined || errorText === '') {
                        errorText = `(backend error: ${result.errorCode ?? ''}: ${errorObject.code ?? ''}, ${errorObject.message ?? ''}, ${errorObject.keys ?? ''})`;
                    }
                    if (errorObject.keys) {
                        errorText += ` ${errorObject.keys}`;
                    }
                    errorText = ` ${errorText}`;
                    console.error(errorText);
                    errorMessage.innerHTML = originalErrorText + errorText;

                    errorMessage.style.display = 'block';
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                const errorMessage = document.querySelector('#jobdetails-application-error-message');
                errorMessage.style.display = 'block';
            } finally {
                loadingElement.style.display = 'none';
            }
        } else {
            loadingElement.style.display = 'none';
        }
    };

    const handleDelete = async (fileName, fileType, fileSize, divId) => {
        const uploadCvList = document.querySelector(`#upload-cv-title`);
        const uploadCoverLetterList = document.querySelector(`#upload-cover-letter-title`);
        const countAttachedOtherFiles = document.querySelector('.count-attached');
        const countAttachedOtherFilesValue = document.querySelector('.count-attached-value');
        const urlPrefix = window.location.hostname === 'localhost' && (window.location.port === '8080' || window.location.port === '8081')
            ? '/belimo-local-mysql'
            : '';

        const request = await fetch(`${urlPrefix}/.rest/successfactors/v1/job-details/document-remove?uploadId=${uploadId}&documentType=${fileType}&fileName=${encodeURIComponent(fileName)}`);
        const result = await request.json();

        if (!result.error) {
            currentFileSizeTotal -= fileSize;
            document.querySelector(`#${divId}`).remove();

            if (fileType === 'resume') {
                const resumeInput = document.querySelector('#upload-cv');
                resumeInput.value = null;
            }

            if (fileType === 'attachment1') {
                const previewContainer = document.querySelector('#upload-other-title');
                const currentCount = previewContainer.childElementCount;

                if (currentCount === 0) {
                    countAttachedOtherFilesValue.textContent = '';
                    countAttachedOtherFiles.classList.remove('notEmpty');
                } else {
                    countAttachedOtherFilesValue.textContent = `${currentCount}`;
                }
            }

            if (uploadCvList && uploadCvList.querySelectorAll('li').length === 0) {
                uploadCvList.classList.remove('notEmpty');
            }
            if (uploadCoverLetterList && uploadCoverLetterList.querySelectorAll('li').length === 0) {
                uploadCoverLetterList.classList.remove('notEmpty');
            }
        }
    };

    const cleanFilename = (filename) => {
        // Replace Umlaute (DE)
        const map = {
            'ä': 'ae', 'ö': 'oe', 'ü': 'ue',
            'Ä': 'Ae', 'Ö': 'Oe', 'Ü': 'Ue',
            'ß': 'ss'
        };
        filename = filename.replaceAll(/[äöüÄÖÜß]/g, (match) => map[match]);
        // Replace everything except alphanumeric characters, spaces, hyphens, underscores, and periods with 'x'
        return filename.replaceAll(/[^a-zA-Z0-9 \-_.]/g, 'x');
    };

    /**
     *
     * This is an example for file uplaod from:
     * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
     */
    const handleUpload = async (event) => {
        const inputField = event.target;
        let previewContainer = null;
        const uploadError = inputField.closest('nxt-file-upload').querySelector('#upload-file-error');
        const sizeError = inputField.closest('nxt-file-upload').querySelector('#size-file-error');
        const noFileError = inputField.closest('nxt-file-upload').querySelector('#no-file-error');
        const totalSizeError = inputField.closest('nxt-file-upload').querySelector('#total-size-error');
        const countAttachedOtherFiles = inputField.closest('nxt-file-upload').querySelector('.count-attached');
        const countAttachedOtherFilesValue = inputField.closest('nxt-file-upload').querySelector('.count-attached-value');

        if (uploadError) {
            uploadError.slot = 'error-hidden';
        }

        if (sizeError) {
            sizeError.slot = 'error-hidden';
        }

        if (noFileError) {
            noFileError.slot = 'error-hidden';
        }

        if (totalSizeError) {
            totalSizeError.slot = 'error-hidden';
        }

        const fieldName = inputField.name;
        const fieldTypeMap = {
            'upload-cv': 'resume',
            'upload-cover-letter': 'coverLetter',
            'upload-other': 'attachment1'
        };
        const fieldType = fieldTypeMap[fieldName] ?? '';

        const curFiles = inputField.files;

        if (curFiles.length === 0) {
            noFileError.slot = 'error';
        } else {
            const originalFile = curFiles[0];
            const file = new File([originalFile], cleanFilename(originalFile.name), { type: originalFile.type });
            const formData = new FormData();
            formData.append(fieldName, file);
            formData.append('type', fieldType);

            if (file.size > maxFileSize) {
                sizeError.slot = 'error-hidden';
                return;
            }

            if (currentFileSizeTotal + file.size > maxTotalFilesSize) {
                totalSizeError.slot = 'error';
                return;
            }

            if (uploadId) {
                formData.append('uploadId', uploadId);
            }

            const urlPrefix = window.location.hostname === 'localhost' && (window.location.port === '8080' || window.location.port === '8081')
                ? '/belimo-local-mysql'
                : '';
            fetch(`${urlPrefix}/.rest/successfactors/v1/job-details/document-preupload`, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            }).then(async (response) => {
                const res = await response.json();
                if (!res.error) {
                    if (!uploadId) {
                        uploadId = res.uploadId;
                    }
                    currentFileSizeTotal += file.size;
                    const li = document.createElement('li');
                    li.id = `id-${Date.now()}`;
                    const div = document.createElement('div');
                    div.innerHTML = `<span>${file.name}</span>`;
                    const spanClose = document.createElement('span');
                    spanClose.innerHTML = 'x';
                    spanClose.style.color = 'rgb(255,102,0)';
                    spanClose.addEventListener('click', () => handleDelete(file.name, fieldType, file.size, li.id));
                    spanClose.style.cursor = 'pointer';
                    div.appendChild(spanClose);
                    li.appendChild(div);
                    if (previewContainer) {
                        previewContainer.append(li);
                        if (previewContainer.id !== 'upload-other-title' && previewContainer.querySelectorAll('li').length > 0) {
                            previewContainer.classList.add('notEmpty');
                        }
                    }
                    if (fieldName === 'upload-other' && countAttachedOtherFiles) {
                        const currentCount = previewContainer.childElementCount;
                        countAttachedOtherFilesValue.textContent = `${currentCount}`;
                        countAttachedOtherFiles.classList.add('notEmpty');
                    }
                }
            });
        }
    };

    jobApplication();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJobApplication);
} else {
    initJobApplication();
}
